<template>
    <transition name="popup" :duration="transitionDurationMs">
        <div class="popup" :data-popup-priority="priority" :data-popup-status="this.isFinalVisible ? 'visible' : 'hidden'" v-show="this.isFinalVisible">
            <div class="popup-table">
                <div class="popup-cell" :class="[position]">
                    <div class="popup-content" :class="[design, size]">
                        <div class="popup-main-content">
                            <div class="section-boxed sides" :class="[width]">
                                <slot :hide="hide" :params="params" :set-param="setParam"></slot>
                            </div>
                        </div>
                        <div v-if="clickAwayToDismiss" class="popup-fake-close" @click="hide"></div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import smartToggle from "../../mixins/smartToggle";

    export default {
        name: 'Popup',

        mixins: [smartToggle],

        props: {
            priority: Number,
            size: String,
            design: String,
            position: {
                type: String,
                default: 'middle',
            },
            width: String,
            clickAwayToDismiss: {type: Boolean, default: true},
            cookie: {type: String, required: false},
            cookieDuration: {type: Number, default: 0},
            transitionDurationMs: {type: Number, default: 0},
            delayDisplay: {type: Number, default: 0},
        },

        data() {
            return {
                params: {},
                withCookie: true,
            };
        },

        watch: {
            isVisible(newValue) {
                if (this.cookie && this.withCookie) {
                    if (newValue) {
                        $cookies.remove(this.cookie);
                    } else {
                        $cookies.set(this.cookie, 1, this.cookieDuration);
                    }
                }
                this.withCookie = true;
            },
        },

        methods: {
            hide(withCookie = true) {
                this.withCookie = !!withCookie;

                // Mixin behavior
                this.isVisible = false;
            },

            setParam(path, value) {
                this.$set(this.params, path, value);
            },

            setParams(params) {
                this.params = params;
            },
        },

        mounted() {
            if ( this.delayDisplay) {
                setTimeout(() => {
                    this.isVisible = true;
                }, this.delayDisplay)
            }
        },
    }
</script>
